<div class="p-6 space-y-5">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">{{ error }}</div>
  }
  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-5">

    <!-- Datos generales -->
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="name" maxlength="150" placeholder="Ej: Premium 24/7"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('name')"
        [class.border-gray-300]="!hasError('name')" />
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
      <textarea formControlName="description" rows="2"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Orden</label>
      <input type="number" formControlName="sortOrder"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
    </div>
    <div class="space-y-2">
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isDefault" class="rounded border-gray-300 dark:border-gray-600" />
        Default (solo una por business)
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isActive" class="rounded border-gray-300 dark:border-gray-600" />
        Activa
      </label>
    </div>

    <!-- Condiciones de activación (appliesWhen) -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700 space-y-4">
      <div>
        <h3 class="text-sm font-semibold text-gray-800 dark:text-gray-100">Condiciones de activación</h3>
        <p class="text-xs text-gray-400 mt-0.5">
          La política aplica solo a tickets que cumplan lo seleccionado. Si dejas un grupo vacío, no filtra por ese criterio (aplica a todos).
        </p>
      </div>

      <!-- Prioridad -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Prioridad</label>
        @if (priorities.length) {
          <div class="flex flex-wrap gap-2">
            @for (p of priorities; track p.id) {
              <label class="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-sm cursor-pointer select-none"
                [class.border-brand-500]="selectedPriorities.includes(p.id)"
                [class.bg-brand-50]="selectedPriorities.includes(p.id)"
                [class.dark:bg-brand-500/10]="selectedPriorities.includes(p.id)"
                [class.text-brand-700]="selectedPriorities.includes(p.id)"
                [class.dark:text-brand-300]="selectedPriorities.includes(p.id)"
                [class.border-gray-300]="!selectedPriorities.includes(p.id)"
                [class.dark:border-gray-600]="!selectedPriorities.includes(p.id)"
                [class.text-gray-700]="!selectedPriorities.includes(p.id)"
                [class.dark:text-gray-300]="!selectedPriorities.includes(p.id)">
                <input type="checkbox" class="hidden" [checked]="selectedPriorities.includes(p.id)" (change)="togglePriority(p.id)" />
                {{ p.label }}
              </label>
            }
          </div>
        } @else {
          <p class="text-xs text-gray-400">No hay prioridades configuradas.</p>
        }
      </div>

      <!-- Categoría -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Categoría</label>
        @if (categoryOptions.length) {
          <div class="max-h-40 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700 p-2 space-y-1">
            @for (c of categoryOptions; track c.id) {
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                <input type="checkbox" class="rounded border-gray-300 dark:border-gray-600"
                  [checked]="selectedCategories.includes(c.id)" (change)="toggleCategory(c.id)" />
                <span class="whitespace-pre">{{ c.label }}</span>
              </label>
            }
          </div>
        } @else {
          <p class="text-xs text-gray-400">No hay categorías configuradas.</p>
        }
      </div>

      <!-- Pipeline -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Pipeline</label>
        @if (pipelines.length) {
          <div class="flex flex-wrap gap-2">
            @for (pl of pipelines; track pl.id) {
              <label class="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-sm cursor-pointer select-none"
                [class.border-brand-500]="selectedPipelines.includes(pl.id)"
                [class.bg-brand-50]="selectedPipelines.includes(pl.id)"
                [class.dark:bg-brand-500/10]="selectedPipelines.includes(pl.id)"
                [class.text-brand-700]="selectedPipelines.includes(pl.id)"
                [class.dark:text-brand-300]="selectedPipelines.includes(pl.id)"
                [class.border-gray-300]="!selectedPipelines.includes(pl.id)"
                [class.dark:border-gray-600]="!selectedPipelines.includes(pl.id)"
                [class.text-gray-700]="!selectedPipelines.includes(pl.id)"
                [class.dark:text-gray-300]="!selectedPipelines.includes(pl.id)">
                <input type="checkbox" class="hidden" [checked]="selectedPipelines.includes(pl.id)" (change)="togglePipeline(pl.id)" />
                {{ pl.name }}
              </label>
            }
          </div>
        } @else {
          <p class="text-xs text-gray-400">No hay pipelines configurados.</p>
        }
      </div>

      <!-- Origen -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Origen</label>
        <div class="flex flex-wrap gap-2">
          @for (s of sources; track s) {
            <label class="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-sm cursor-pointer select-none"
              [class.border-brand-500]="selectedSources.includes(s)"
              [class.bg-brand-50]="selectedSources.includes(s)"
              [class.dark:bg-brand-500/10]="selectedSources.includes(s)"
              [class.text-brand-700]="selectedSources.includes(s)"
              [class.dark:text-brand-300]="selectedSources.includes(s)"
              [class.border-gray-300]="!selectedSources.includes(s)"
              [class.dark:border-gray-600]="!selectedSources.includes(s)"
              [class.text-gray-700]="!selectedSources.includes(s)"
              [class.dark:text-gray-300]="!selectedSources.includes(s)">
              <input type="checkbox" class="hidden" [checked]="selectedSources.includes(s)" (change)="toggleSource(s)" />
              {{ getOrigenLabel(s) }}
            </label>
          }
        </div>
      </div>

      <p class="text-xs text-gray-400">
        Las condiciones por contacto o empresa aún no se evalúan del lado del servidor.
      </p>
    </div>

    <!-- Horario laboral (businessHours) -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700 space-y-3">
      <div>
        <h3 class="text-sm font-semibold text-gray-800 dark:text-gray-100">Horario laboral</h3>
        <p class="text-xs text-gray-400 mt-0.5">
          Días y horas en que corre el reloj del SLA. Si no marcas ningún día, se considera 24/7.
        </p>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Zona horaria <span class="text-gray-400">(opcional)</span></label>
        <input type="text" formControlName="timezone" placeholder="Ej: America/Lima"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      </div>
      <div class="space-y-2">
        @for (d of businessHoursDays; track d.day) {
          <div class="flex items-center gap-3 flex-wrap">
            <label class="flex items-center gap-2 w-28 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
              <input type="checkbox" class="rounded border-gray-300 dark:border-gray-600"
                [(ngModel)]="d.enabled" [ngModelOptions]="{ standalone: true }" />
              {{ d.label }}
            </label>
            <div class="flex items-center gap-2" [class.opacity-40]="!d.enabled">
              <input type="time" [(ngModel)]="d.start" [ngModelOptions]="{ standalone: true }" [disabled]="!d.enabled"
                class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 disabled:cursor-not-allowed" />
              <span class="text-xs text-gray-400">a</span>
              <input type="time" [(ngModel)]="d.end" [ngModelOptions]="{ standalone: true }" [disabled]="!d.enabled"
                class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 disabled:cursor-not-allowed" />
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Días festivos (holidays) -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700 space-y-3">
      <div>
        <h3 class="text-sm font-semibold text-gray-800 dark:text-gray-100">Días festivos</h3>
        <p class="text-xs text-gray-400 mt-0.5">Fechas en que el reloj del SLA se detiene.</p>
      </div>
      <div class="flex items-center gap-2">
        <input type="date" [(ngModel)]="newHoliday" [ngModelOptions]="{ standalone: true }"
          class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
        <app-button variant="outline" type="button" (btnClick)="addHoliday()">Agregar</app-button>
      </div>
      @if (holidays.length) {
        <div class="flex flex-wrap gap-2">
          @for (h of holidays; track h) {
            <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gray-100 dark:bg-gray-800 text-sm text-gray-700 dark:text-gray-300">
              {{ h }}
              <button type="button" (click)="removeHoliday(h)"
                class="text-gray-400 hover:text-error-500" aria-label="Quitar">&times;</button>
            </span>
          }
        </div>
      } @else {
        <p class="text-xs text-gray-400">Sin días festivos configurados.</p>
      }
    </div>

    <!-- Acciones -->
    <div class="flex justify-end gap-2 pt-4 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Guardar' }} }
      </app-button>
    </div>
  </form>
</div>
